import type { FC } from 'react';
import { MarkdownContent, Date, Title } from '../../share';

const privacy = `
## 第1条（目的）
本プライバシーポリシーは、そぽたん商店（以下「当開発チーム」といいます。）が提供する「Pay Crew2」（以下「本サービス」といいます。）において、当開発チームが取得する個人情報の取扱いについて定めるものです。当開発チームは、個人情報の保護を重要な責務と考え、関連法令を遵守し、お客様の個人情報を適切に管理いたします。

## 第2条（定義）
本プライバシーポリシーにおいて使用する用語の定義は、以下の通りとします。
1. 「個人情報」とは、個人情報保護法に定める「個人情報」をいいます。具体的には、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別することができるもの（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含む。）を指します。
2. 「利用者」とは、本サービスを利用する個人または法人をいいます。
3. 「GoogleおよびDiscordのIdP」とは、GoogleアカウントまたはDiscordアカウントを利用して本サービスに認証を行う仕組みをいいます。
4. 「better-auth」とは、当開発チームが利用する認証システムを構築するためのnpm packageをいいます。
5. 「台帳」とは、本サービスにおいて記録される貸し借りの情報を含むデータをいいます。

## 第3条（個人情報の取得）
当開発チームは、本サービスの提供にあたり、以下の情報を取得します。
1. GoogleおよびDiscordのIdPを使用した認証システムを構築するために必要な情報（better-authを通じて取得される情報を含みます。）
2. 台帳に記載されたデータ

## 第4条（個人情報の利用目的）
当開発チームは、取得した個人情報を、以下の目的のために利用します。
1. 本サービスの提供、運営、維持、改善のため
2. 利用者認証のため
3. 貸し借りの登録、共通の台帳管理、複数のグループを越えた個人間の貸し借りの合算、登録された台帳奇特の返金処理、返金処理の取り消しといった本サービスの機能を提供するため
4. その他、上記利用目的に付随する目的のため

## 第5条（個人情報の第三者提供）
当開発チームは、法令に基づく場合または本人の同意を得た場合を除き、取得した個人情報を第三者に提供することはありません。

## 第6条（個人情報の安全管理措置）
当開発チームは、個人情報の漏洩、滅失、毀損等を防止するため、必要な措置を講じ、個人情報を適切に管理いたします。

## 第7条（個人情報の開示、訂正、削除等）
当開発チームは、利用者から自己の個人情報について、開示、訂正、追加、削除等を求められた場合には、法令に基づき適切に対応いたします。

## 第8条（サービス内容の変更および終了）
1. 当開発チームは、利用者に予告なく、本サービスの全部または一部の内容を変更し、または提供を終了することがあります。
2. 当開発チームは、本サービスの提供を終了する場合、またはシステム構成や依存しているサービスを変更する場合、利用者の個人情報を含む全てのデータを破棄することがあります。この場合、当開発チームは、当該破棄について、利用者に対して事前に通知する義務を負いません。

## 第9条（Cookie（クッキー）その他の技術の利用）
当開発チームは、利用者の利便性向上、利用状況の把握、広告配信等の目的で、Cookieその他の類似技術を利用することがあります。利用者は、ブラウザの設定によりCookieの受け取りを拒否したり、受信したCookieを削除したりすることができますが、その場合、本サービスの一部の機能が利用できなくなる可能性があります。

## 第10条（本プライバシーポリシーの変更）
当開発チームは、本プライバシーポリシーの全部または一部を改定することがあります。改定されたプライバシーポリシーは、当開発チームのウェブサイト等に掲載された時点から効力を生じるものとします。

以上
`;

const Privacy: FC = () => {
  return (
    <>
      <Title title="プライバシーポリシー" />
      <Date content="最終更新日：2026年1月21日" />
      <MarkdownContent content={privacy} />
    </>
  );
};

export default Privacy;
